<template>
  <div>
    <p>You can only view this when you are logged in!!!</p>
  </div>
</template>

<script>
export default {
  name: 'Protected',
}
</script>